import Cookies from 'js-cookie'
export default function Dictionary() {
    const lang=Cookies.get("lang")
    switch(lang){
    default:
        Cookies.set("lang","fr")
        return [require('./constants/fr')]
    }
}